import { render, staticRenderFns } from "./captainCard.vue?vue&type=template&id=c83cecd8&scoped=true&"
import script from "./captainCard.vue?vue&type=script&lang=js&"
export * from "./captainCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83cecd8",
  null
  
)

export default component.exports